import React, { useEffect, useMemo } from "react";
import { NATIVE, getChainById, stringToBlobUrl } from "common";
import { useCartStorage } from "../../../store";
import { parseChainId } from "common/src/chains";
import { Checkbox } from "@chakra-ui/react";
import { DonateToGitcoin } from "../DonateToGitcoin";
import { zeroAddress } from "viem";
import { useDonateToGitcoin, GITCOIN_RECIPIENT_CONFIG } from "../DonateToGitcoinContext";
import { TotalAmountInclGitcoinDonation } from "../DonateToGitcoin/components/TotalAmountInclGitcoinDonation";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ChainConfirmationModalBody(_ref) {
  let {
    projectsByChain,
    totalDonationsPerChain,
    chainIdsBeingCheckedOut,
    enoughBalanceByChainId,
    setChainIdsBeingCheckedOut,
    handleSwap,
    totalDonationAcrossChainsInUSD
  } = _ref;
  const {
    setTokenFilters
  } = useDonateToGitcoin();
  const handleChainCheckboxChange = (chainId, checked) => {
    if (checked) {
      setChainIdsBeingCheckedOut(prevChainIds => prevChainIds.includes(chainId) ? prevChainIds : [...prevChainIds, chainId]);
    } else {
      setChainIdsBeingCheckedOut(prevChainIds => prevChainIds.filter(id => id !== chainId));
    }
  };
  const getVotingTokenForChain = useCartStorage(state => state.getVotingTokenForChain);
  const parsedChainIds = useMemo(() => Object.keys(projectsByChain).map(parseChainId), [projectsByChain]);
  const tokenFilters = useMemo(() => parsedChainIds.map(chainId => ({
    chainId,
    addresses: [getVotingTokenForChain(chainId).address === zeroAddress ? NATIVE : getVotingTokenForChain(chainId).address]
  })), [parsedChainIds, getVotingTokenForChain]);
  useEffect(() => {
    setTokenFilters(tokenFilters);
  }, [tokenFilters, setTokenFilters]);
  const hasGitcoinSupportedChain = chainIdsBeingCheckedOut.some(chainId => chainId in GITCOIN_RECIPIENT_CONFIG);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/_jsx("p", {
      className: "text-sm text-grey-400",
      children: chainIdsBeingCheckedOut.length > 1 && /*#__PURE__*/_jsx(_Fragment, {
        children: "Checkout all your carts across different networks or select the cart you wish to checkout now."
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex flex-col border-b border-[#D7D7D7] py-6",
        children: [/*#__PURE__*/_jsx("span", {
          className: "font-inter text-[15px] font-medium text-black pb-2",
          children: "Networks"
        }), parsedChainIds.filter(chainId => chainIdsBeingCheckedOut.includes(chainId)).map((chainId, index) => /*#__PURE__*/_jsx(ChainSummary, {
          chainId: chainId,
          selectedPayoutToken: getVotingTokenForChain(chainId),
          totalDonation: totalDonationsPerChain[chainId],
          checked: chainIdsBeingCheckedOut.includes(chainId) && enoughBalanceByChainId[chainId],
          chainsBeingCheckedOut: chainIdsBeingCheckedOut.length,
          onChange: checked => handleChainCheckboxChange(chainId, checked)
          // isLastItem={index === Object.keys(projectsByChain).length - 1}
          ,
          isLastItem: true,
          notEnoughBalance: !enoughBalanceByChainId[chainId],
          handleSwap: () => handleSwap(chainId)
        }, chainId))]
      }), /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [hasGitcoinSupportedChain && /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between items-center py-3 mb-6 border-b border-[#D7D7D7]",
          children: [/*#__PURE__*/_jsx("span", {
            className: "font-inter text-[15px] font-medium text-black",
            children: "Subtotal"
          }), /*#__PURE__*/_jsxs("span", {
            className: "font-inter text-[15px] font-medium text-black",
            children: ["~$", totalDonationAcrossChainsInUSD.toFixed(2)]
          })]
        }), hasGitcoinSupportedChain ? /*#__PURE__*/_jsx(DonateToGitcoin, {
          totalAmount: totalDonationAcrossChainsInUSD.toFixed(2),
          totalDonationsByChain: totalDonationsPerChain
        }) : /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between items-center mb-3 py-3",
          children: [/*#__PURE__*/_jsx("span", {
            className: "font-inter text-[15px] font-medium text-black",
            children: "Total"
          }), /*#__PURE__*/_jsx(TotalAmountInclGitcoinDonation, {
            totalDonationAcrossChainsInUSD: totalDonationAcrossChainsInUSD
          })]
        }), hasGitcoinSupportedChain && /*#__PURE__*/_jsx("div", {
          className: "pt-6",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between items-center py-3 border-y mb-3 border-[#D7D7D7]",
            children: [/*#__PURE__*/_jsx("span", {
              className: "font-inter text-[15px] font-medium text-black",
              children: "Total"
            }), /*#__PURE__*/_jsx(TotalAmountInclGitcoinDonation, {
              totalDonationAcrossChainsInUSD: totalDonationAcrossChainsInUSD
            })]
          })
        })]
      })]
    })]
  });
}
export function ChainSummary(_ref2) {
  let {
    selectedPayoutToken,
    totalDonation,
    chainId,
    checked,
    chainsBeingCheckedOut,
    notEnoughBalance,
    onChange,
    isLastItem,
    handleSwap
  } = _ref2;
  const chain = getChainById(chainId);
  return /*#__PURE__*/_jsxs("div", {
    className: `flex flex-col justify-center ${isLastItem ? "" : "border-b"} py-2`,
    children: [/*#__PURE__*/_jsxs("div", {
      className: `flex justify-between items-center ${notEnoughBalance ? "opacity-50" : ""}`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          className: `mr-2 ${chainsBeingCheckedOut === 1 ? "invisible" : ""}`,
          border: "1px",
          borderRadius: "4px",
          colorScheme: "whiteAlpha",
          iconColor: "black",
          size: "lg",
          isChecked: checked,
          disabled: chainsBeingCheckedOut === 1 || notEnoughBalance,
          onChange: e => onChange(e.target.checked)
        }), /*#__PURE__*/_jsx("img", {
          className: "inline mr-2 w-5 h-5",
          alt: chain.prettyName,
          src: stringToBlobUrl(chain.icon)
        }), /*#__PURE__*/_jsx("span", {
          className: "font-sans font-medium",
          children: chain.prettyName
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-right",
        children: [/*#__PURE__*/_jsx("span", {
          "data-testid": "totalDonation",
          className: "mr-2 font-dm-mono text-[14px] font-medium leading-[21px] text-black",
          children: totalDonation
        }), /*#__PURE__*/_jsx("span", {
          "data-testid": "chainSummaryPayoutToken",
          className: "font-dm-mono text-[14px] font-medium leading-[21px] text-black",
          children: selectedPayoutToken.code
        })]
      })]
    }), notEnoughBalance && /*#__PURE__*/_jsx("div", {
      className: "text-red-500 flex items-center text-sm mt-2",
      children: /*#__PURE__*/_jsxs("p", {
        children: ["There are insufficient funds in your wallet to complete your full donation. Please", " ", /*#__PURE__*/_jsx("span", {
          onClick: () => handleSwap(),
          className: "cursor-pointer underline",
          children: "bridge"
        }), " ", "funds over to ", getChainById(chainId).prettyName, "."]
      })
    })]
  });
}